/* Styles */
import '@/scss/main.scss'
import '@mdi/font/css/materialdesignicons.css'
import 'leaflet/dist/leaflet.css'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import 'mapbox-gl/dist/mapbox-gl.css'
import '@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css'

/* Core */
import Vue from 'vue'
import Buefy from 'buefy'

/* Router & Store */
import store from './store'
import router from './router'

/* Firebase */
import * as firebase from 'firebase/app'
import 'firebase/messaging'

/* Vue. Main component */
import App from './App.vue'

import Notification from '@/components/base/Notification'
import CardComponent from '@/components/base/CardComponent'

// Set default marker icon
import { Icon } from 'leaflet'

// Register service worker
import { register } from 'register-service-worker'

delete Icon.Default.prototype._getIconUrl
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
})

const firebaseConfig = {
  apiKey: "AIzaSyDNCoBQ3hwyxeibJSLogfb4D8mmp4RCk1o",
  authDomain: "firelogic-fb1f0.firebaseapp.com",
  databaseURL: "https://firelogic-fb1f0.firebaseio.com",
  projectId: "firelogic-fb1f0",
  storageBucket: "firelogic-fb1f0.appspot.com",
  messagingSenderId: "133756286499",
  appId: "1:133756286499:web:4df75e54c6382c5f2c2396",
  measurementId: "G-EBL0W3M86D"
}

// Initialize Firebase
firebase.initializeApp(firebaseConfig)

Vue.prototype.$messaging = firebase.messaging()
Vue.prototype.$messaging.usePublicVapidKey('BGMounzBuRIAuT9Ctba5WQINMJaLswCj8OMijhHJZTuhKtBMX-aGcUmeYYGdn4HsqFjGnEyXoAl8MJHcH6dtWSs')

/* Collapse mobile aside menu on route change */
router.afterEach(() => {
  store.commit('asideMobileStateToggle', false)
})

Vue.config.productionTip = false

/* These components are used in recursion algorithm */
Vue.component('Notification', Notification)
Vue.component('CardComponent', CardComponent)

Vue.use(Buefy)

register('/service-worker.js', {
  ready() {
    // console.log(
    //   'App is being served from cache by a service worker.\n' +
    //     'For more details, visit https://goo.gl/AFskqB'
    // )
  },
  registered() {
    // console.log('Service worker has been registered.')
  },
  cached() {
    // console.log('Content has been cached for offline use.')
  },
  updatefound(reg) {
    const installingWorker = reg.installing
    installingWorker.onstatechange = () => {
      switch (installingWorker.state) {
        case 'installed':
          if (navigator.serviceWorker.controller) {
            // new update available
            Buefy.DialogProgrammatic.confirm({
              message: 'New update detected. Reload page to update.',
              canCancel: false,
              onConfirm: () => {
                caches.keys().then(names => {
                  for (let name of names) caches.delete(name)
                  location.reload()
                })
              }
            })
          }
          break
      }
    }
  },
  updated() {
    // console.log('Updated.')
  },
  offline() {
    // console.log('No internet connection found. App is running in offline mode.')
  },
  error() {
    // console.error('Error during service worker registration:', error)
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
